import React from 'react';

import './css/main.css';
import './css/animations.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

import MainScreen from './components/MainScreen';
import Companies from './components/Companies';

function App()
{
  return (
    <section>
      <MainScreen />
      <Companies />
    </section>
  );
}

export default App;
